import { NavLink } from 'react-router-dom';
import useMenu from '@/features/hooks/useMenu';
import Layout from '../Layouts';
import Dashboard from '@/routes/dashboard';
import { renderIcon } from '@/utils/iconRenderer';
import { useTranslation } from 'react-i18next';

function MenuPage() {
  const { currentMenus, selectedComponentHandler, CurrentComponent } =
    useMenu();
  const { t } = useTranslation();
  const navClickHandler = (e) => {
    const selectedMenuId = e.currentTarget.value;
    selectedComponentHandler(selectedMenuId);
  };

  const menuItems = currentMenus.filter((item) => item.isShowMenu);
  const hasWindow = typeof window !== 'undefined';
  const width = hasWindow ? window.innerWidth : null;

  return (
    <Layout>
      <div className="container mx-auto py-2">
        <div className="flex flex-wrap gap-2 justify-center">
          {menuItems.map((menu) => (
            <NavLink
              to={menu.to}
              key={menu.name}
              value={menu.id}
              className="p-1 col-3 lg:col-2 text-sm  w-[100px] h-[100px] bg-white  text-color-text-gray  shadow-xl  text-center relative transition-all duration-300 ease-in-out cursor-pointer border-2 border-transparent hover:-translate-y-1 hover:shadow-lg hover:bg-color-text-gray hover:border-color-border flex flex-col items-center justify-center gap-2  rounded-lg"
              onClick={navClickHandler}>
              {renderIcon(menu.icon, 32)}
              <p className="text-[14px] w-[80px] truncate transition-colors duration-300">
                {menu.name.length > 0 &&
                menu.name.indexOf(' ') === -1 &&
                width < 600
                  ? `${t(menu.name).substr(0, 12)}..`
                  : t(menu.name)}
              </p>
            </NavLink>
          ))}
        </div>
        <div className="mt-4">
          {CurrentComponent ? <CurrentComponent /> : <Dashboard />}
        </div>
      </div>
    </Layout>
  );
}

export default MenuPage;
